'use client';

import { Loader2 } from 'lucide-react';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { useAuth } from '@/features/auth/context/auth-context';

const INITIAL_PAGE = '/chat/new';

const Page: React.FC = () => {
  const router = useRouter();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      router.replace(`/auth/login?returnTo=${encodeURIComponent(INITIAL_PAGE)}`);
    } else if (!isLoading && isAuthenticated) {
      router.replace(INITIAL_PAGE);
    }
  }, [isAuthenticated, isLoading, router]);

  // Show a loading screen while we check the authentication or redirect to the
  // login page.
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  );
};

export default Page;
